import { useEffect } from "react";
import { useAuth } from "../context/Auth.context";
import { useLogoutContext } from "../context/LogoutContext";
import { useNavigate } from "react-router-dom";

export default function Logout() {
  const { logout } = useAuth();
  const { showLogoutMessage } = useLogoutContext();
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    showLogoutMessage("Succesvol uitgelogd");
    navigate("/"); 
  }, [logout, navigate, showLogoutMessage]);

  return null; 
}
